export function getSpecialisms(categories) {
  let formatted = "";
  if(categories) {
    const contracts = categories.filter(category => category.name === "Specialisms");
    contracts.forEach((item) => {
      item.values.forEach((value) => {
        if(value.name != "Contract" && value.name != "Remote" && value.name != "Permanent") {
          if(formatted != "") formatted += ", ";
        formatted += value.name;
        }
      })
    });
  } else {
    formatted = "-";
  }
  return formatted;
}